export default "__VITE_ASSET__DtkpQc$j__"